<template>
    <div class="w-full text-center top-1/2 absolute dark:text-white" v-if="loading">
        <font-awesome-icon icon="fas fa-spinner" class="animate-spin text-2xl" />
    </div>
    <div class="container sm:ml-24 grid md:grid-cols-2 justify-center gap-5 mt-5 mb-20 sm:mb-0" v-else>
        <section v-if="profile_done_status<100 && myself?.position <= 3" class="w-full px-2 sm:px-0 w-full dark:text-dark.textOnBkg">
            <h2 class="mb-1">{{ $t('profile_setup_status') }} <strong>{{profile_done_status}}%</strong></h2>
            <div class="h-3 mb-5 rounded bg-gray-200">
                <div class="h-3 bg-growth rounded" :style="'width:' + profile_done_status + '%'"></div>
            </div>
            <slot v-for="(task,index) in agency_status.to_do" :key="index">
                <div class="p-3 px-4 rounded border border-sepBorder dark:border-dark.sepBorder w-full mt-2 mb-4 relative" :class="task.done ? 'bg-gray-200 dark:bg-dark.tableBG opacity-80': 'cursor-pointer'" 
                    @click="openModal(task)">
                    <h2 :class="task.done ? 'font-semibold text-base' : 'font-bold text-lg'">{{index+1}}. {{ $t('setup_steps.' + task.action + '[0]') }}</h2>
                    <p class="mt-1" v-if="task.done == false">{{ $t('setup_steps.' + task.action + '[1]') }}</p>
                    <font-awesome-icon v-if="task.done" icon="fas fa-check fa-2xl" class="text-2xl absolute right-3 top-3 text-growth"/>
                </div>
            </slot>
        </section>
        <section v-else-if="myself?.app_downloaded == 0 && !isElectron" class="mt-6 px-2 sm:px-0 w-full dark:text-dark.textOnBkg">
            <h2 class="mb-1 font-bold text-lg">{{ $t('to_do') }}:</h2>
            <div @click="$router.push('tools')" class="relative hover:bg-gray-200 dark:hover:bg-gray-700 p-3 px-4 rounded border border-sepBorder dark:border-dark.sepBorder max-w-2xl mt-2 mb-4 relative cursor-pointer">
                <h2 class="font-bold"><font-awesome-icon icon="fa-solid fa-download" class="mr-2"/>{{ $t('desktop_app_download') }}</h2>
                <button @click.stop.prevent="markAsDownloaded()" class="absolute right-2 top-2 p-0.5 px-3 bg-growth rounded-full text-sm text-white">{{ $t('mark_as_done') }} <font-awesome-icon icon="fa-solid fa-check" /></button>
                <p class="mt-2 text-sm">{{ $t('for_cxoneapp_1') }}</p>
            </div>
        </section>
        <section v-if="myself" class="w-full p-5 bg-white dark:bg-dark.tableBG text-textOnBkg dark:text-dark.textOnBkg shadow-light dark:shadow-dark rounded-lg grid gap-3 font-semibold h-max">
            <div>
                <strong class="text-lg">{{myself?.branchName}}</strong><br />
                <section class="flex pb-5 grid xl:grid-cols-2 gap-3">
                    <div class="mr-2">
                        <div class="mt-2" v-if="editUsername">
                            <MazInput v-model="myself.username" :label="$t('name')" size="sm" />
                            <button @click="save_profile_changes()" class="ml-2 bg-growth text-white font-semibold p-1.5 px-2.5 rounded-lg"><font-awesome-icon :icon="['fas', 'check']" /></button>
                        </div>
                        <slot v-else>
                            <label class="font-normal text-xs">{{ $t('name') }}: </label><br />{{ myself.username }} 
                            <font-awesome-icon @click="editUsername = true" class="cursor-pointer" :icon="['fas', 'pen']" />
                        </slot>
                    </div>
                    <div class="mr-2">
                        <label class="font-normal text-xs">{{ $t('user_id') }}: </label><br />{{ myself?.id }}
                    </div>
                    <div class="mr-2">
                        <label class="font-normal text-xs">{{ $t('reg_form.email') }}:</label><br />{{ myself?.email }}
                    </div>
                    <div><label class="font-normal text-xs">{{ $t('position') }}: </label><br /><span class="capitalize">{{ myself?.positionName.replace("_", " ") }}</span></div>
                    <div>
                        <label class="font-normal text-xs">{{ $t('reg_form.password') }}:</label><br />
                        <button class="mt-1 text-black bg-growth w-max dark:text-block rounded-lg text-sm p-1.5 px-3" @click="modal.display = true, modal.type = 'changePass'">{{ $t('reg_form.update_password') }}</button>
                    </div>
                    <div v-if="myself.userInGroup">
                        <label class="font-normal text-xs">{{ $t('group') }}: </label><br />{{ myself.groupTeam }}
                    </div>
                </section>
            </div>

            <div class="border-t border-sepBorder dark:border-dark.sepBorder pt-5">
                <label class="font-normal text-sm mb-2">{{ $t('subscription') }}: </label><br />
                <slot v-if="agency_status && !agency_status.manual_billing">
                    <slot v-if="cancel_subscription_block == false">
                        <div v-if="!agency_status.to_do[0].done">
                            {{ $t('setup_steps.payment[0]') }}
                        </div>
                        <div v-else-if="agency_status.trial" class="mb-3">
                            <strong>{{ $t('free_trial_will_end') }} {{agency_status.trial_till ? 'till ' + ($moment(agency_status.trial_till).format("DD.MM.YYYY") == $moment().format("DD.MM.YYYY") ? ' ' + $t('today') : $moment(agency_status.trial_till).format("DD.MM.YYYY")) : null}}</strong><br />
                            <span class="text-sm">{{ $t('free_trial_notice[0]') }}<br />
                                {{ $t('free_trial_notice[1]') }}</span>
                        </div>
                        <div v-else-if="agency_status?.subscription_active" class="mb-3">
                            <strong>{{agency_status.next_charge_date ? $t('you_will_be_billed') + ' ' + $moment(agency_status.next_charge_date).format("DD.MM.YYYY") : null}}</strong><br />
                        </div>
                        <div v-else class="mb-3">
                            <strong><font-awesome-icon icon="fa-solid fa-triangle-exclamation" class="text-decline" /> {{ $t('your_subscription_expired') }}</strong><br />
                            <span class="text-sm">{{ $t('renew_subscription_notice') }}</span>
                        </div>
                        <div v-if="!agency_status.to_do[0].done"></div>
                        <button v-else-if="agency_status?.subscription_active" @click="cancel_subscription_block = true" class="border opacity-70 border-decline text-decline p-1 px-2 rounded">{{ $t('cancel_subscription') }}</button>
                        <button v-else @click="renew_subscription()" class="bg-growth text-black font-semibold p-1 px-2.5 rounded">{{ $t('renew_subscription') }}</button>
                        <button v-if="agency_status.to_do[0].done" @click="$router.push('billing')" class="ml-3 border border-growth text-growth font-semibold p-1 px-2.5 rounded">{{ $t('Invoices') }} <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" /></button>
                    </slot>
                    <slot v-else>
                        <h3 class="text-decline my-2">{{ $t('cancel_subscription') }}</h3>
                        <div>
                            <MazSelect 
                                v-model="reason_to_cancel" 
                                :options="cancelation_reasons" 
                                :placeholder="$t('select_reason')"
                            />
                        </div>
                        <div class="mt-3" v-if="reason_to_cancel == 9">
                            <MazInput v-model="reason_to_cancel_text" :label="$t('select_reason')" />
                        </div>
                        <button @click="cancel_subscription()" class="border border-decline text-decline rounded p-1.5 px-2.5 mt-4">{{ $t('confirm_cancelation') }}</button>
                    </slot>
                </slot>
                <slot v-else>{{ $t('manual_billing') }}</slot>
                <div class="text-sm font-light border-t border-sepBorder dark:border-dark.sepBorder pt-5 mt-5">
                    {{ $t('billing_contact') }} 
                    <a href="mailto:info@creatorxone.com" class="cursor-pointer text-inherit no-underline font-semibold">info@creatorxone.com</a>
                </div>
            </div>
        </section>
    </div>

    <transition name="zoom-fade">
        <section v-if="modal.display" @click="modal.display = false" class="backdrop-blur w-full h-full fixed inset-0 bg-gray-700 bg-opacity-30 z-50 flex justify-center items-center px-4 text-black">
            <section @click.stop class="bg-white dark:bg-dark.bkg dark:text-dark.textOnBkg rounded-lg w-full max-w-md mx-auto my-auto p-8 sm:p-12 z-50 relative" :class="{'sm:max-w-max': modal.type == 'changePass', 'sm:max-w-7xl': modal.type != 'changePass'}">
                <font-awesome-icon @click="modal.display = false" icon="fas fa-xmark" class="transition absolute p-6 top-0 right-0 text-xl cursor-pointer hover:opacity-50" />
                <privileges-panel v-if="modal.type == 'permissions'" :noarrow="true" :position_id="3" />
                <shifts-settings v-if="modal.type == 'shifts'" :noarrow="true" @close="handleClose" />
                <employees-form v-if="modal.type == 'employee'" :noarrow="true" @close="handleClose" />
                <models-form v-if="modal.type == 'creator'" :noarrow="true" @close="handleClose" />
                <models-list v-if="modal.type == 'creator_tools'"/>
                <update-password v-if="modal.type == 'changePass'" @close="handleClose" />
                <tools-section v-if="modal.type == 'tools'" :as_component="true" />
                <div v-if="modal.type == 'resend'" class="text-center">
                    <div class="mb-4">
                        {{ $t('verification_notice[0]') }}
                        <div class="italic mt-2">{{ $t('verification_notice[1]') }} <strong>"{{ $t('verification_notice[2]') }}"</strong>.</div>
                    </div>
                    <div class="flex w-max mx-auto">
                        <div class="bg-gray-100 border dark:bg-dark.tableBG border-sepBorder dark:border-dark.sepBorder rounded p-1.5 px-4 mr-3 text-center w-80">{{myself.email}}</div>
                    </div>
                    {{resend_message}}
                    <button @click="resendEmail(myself.email)" class="bg-button text-white rounded p-1.5 px-2.5 mt-4">
                        <font-awesome-icon v-if="button_loading" icon="fas fa-spinner" class="animate-spin mr-2" />{{ $t('verification_notice[2]') }}
                    </button>
                </div>
            </section>
        </section>
    </transition>

    <MazDialog v-model="isDialogOpen" :title="$t('setup_steps.payment_details_required')">
      <p>{{ $t('setup_steps.to_access') }}</p>
      <template #footer>
        <MazBtn @click="isDialogOpen = false">{{ $t('close') }}</MazBtn>
      </template>
    </MazDialog>
</template>

<script setup>
    import privilegesPanel from "@/components/settings/privileges.vue"
    import shiftsSettings from "@/components/settings/shifts.vue"
    import employeesForm from "@/components/settings/employees/employeesForm.vue"
    import modelsForm from "@/components/settings/models/modelsForm.vue"
    import modelsList from "@/components/settings/tools/models_on_tools.vue"
    import updatePassword from "@/components/settings/updatePassword.vue"
    import logoComponent from "@/components/logo.vue"
    import toolsSection from "@/views/Tools.vue"
</script>

<script>
    import { useAuthStore } from '@/stores/auth';
    import { api_get_call, api_post_call } from "@/api/api.js"
    export default {
        data() {
            return {
                editUsername: false,
                modal: {display:false, type: null},
                cancel_subscription_block: false,
                agency_status: null,
                profile_done_status: 100,
                edit_email: false,
                resend_message:null,
                isDialogOpen:false,
                button_loading:false,
                loading:true,
                isElectron: this.$cookies.get('desktop_app_token') == import.meta.env.VITE_API_INTERNAL_KEY_LIST,
                reason_to_cancel: null,
                cancelation_reasons: [
                    { value: 1, label: 'The price is too high.' },
                    { value: 2, label: 'I no longer need this product.' },
                    { value: 3, label: 'I am not satisfied with the product.' },
                    { value: 4, label: 'I switched to another product.' },
                    { value: 5, label: "It isn't a priority right now." },
                    { value: 6, label: 'I subscribed by mistake.' },
                    { value: 8, label: 'I am switching to another subscription plan.' },
                    { value: 9, label: 'Other' }
                ],
            }
        },
        computed: {
            authStore() {
                return useAuthStore();
            },
            myself() {
                return this.authStore.myself;
            },
            permissions() {
                return this.authStore.permissions;
            }
        },
        components() {
            privilegesPanel,
            shiftsSettings,
            employeesForm,
            modelsForm,
            modelsList,
            logoComponent,
            toolsSection
        },
        methods: {
            async handleClose() {
                this.modal.display = false;
                console.log("closing");
                await this.getAgencyStatus();
            },
            async save_profile_changes() {
                this.editUsername = false;
                this.button_loading = true;
                await api_post_call(`users/`, {
                    action: 'update_profile',
                    companyID: this.$cookies.get('c_id'),
                    userToken: this.$cookies.get('userToken'),
                    branchName: this.myself?.branchName,
                    email: this.myself.email,
                    username: this.myself.username
                });
                setTimeout(() => {
                    this.button_loading = false;
                }, 500);
                setTimeout(() => this.$emit('close'), 500);
            },
            markAsDownloaded() {
                this.$axios.get(`githubDownload/?q=markAsDownloaded&userToken=${this.$cookies.get('userToken')}`).then((result) => {
                    this.myself.app_downloaded = 1;
                }, (error) => {
                    console.log(error);
                });
            },
            async resendEmail() {
                this.button_loading = true;
                const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
                if (!emailRegex.test(this.myself.email)) {
                    alert('Invalid email format');
                    return;
                }
                let response = await api_post_call(`users/`, {
                    action: 'resend_verification_email',
                    email : this.myself.email,
                    companyID: this.$cookies.get('c_id'),
                    userToken: this.$cookies.get('userToken')
                });
                if (!response.success) {
                    this.resend_message = response.message;
                } else {
                    this.modal.display = false;
                }
                setTimeout(() => {
                    this.button_loading = false;
                }, 500);
            },
            async openModal(task) {
                if (!task.done) {
                    if (task.action == 'payment') {
                        let response = await api_get_call(`billing/?action=generate_purchase_link&companyID=${this.$cookies.get('c_id')}&userToken=${this.$cookies.get('userToken')}`);
                        if (response.success) {
                            window.open(response.purchase_link, '_blank');
                        }
                        return;
                    } 
                    this.modal.type = task.action;
                    this.modal.display = true;
                }
            },
            async renew_subscription() {
                let renew = await api_post_call(`billing/`, {
                    action: "renew_subscription", 
                    companyID: this.$cookies.get('c_id'), 
                    userToken: this.$cookies.get('userToken')
                });
                if (renew.success && renew.purchase_link) {
                    window.open(renew.purchase_link, '_blank');
                } else {
                    this.agency_status.subscription_active = true;
                    alert('Subscription renewal started. We will try to charge your card again. If the payment fails, we will send you an email with a link to update your payment method.');
                }
            },
            async cancel_subscription() {
                if ((this.reason_to_cancel == 0) || (this.reason_to_cancel == 9 && !this.reason_to_cancel_text)) {
                    alert('Please select a reason for cancellation');
                    return;
                }
                if (confirm('Are you sure you want to cancel your subscription?')) {
                    this.cancel_subscription_block = false;
                    this.agency_status.subscription_active = false;
                    await api_post_call(`billing/`, {
                        action: "cancel_subscription", 
                        companyID: this.$cookies.get('c_id'), 
                        userToken: this.$cookies.get('userToken'), 
                        reason: this.reason_to_cancel, 
                        reason_text: this.reason_to_cancel_text
                    });
                }
            },
            async getAgencyStatus() {
                setTimeout(async() => {
                    this.agency_status = await api_get_call(`users/?action=agency_profile_status&companyID=${this.$cookies.get('c_id')}&userToken=${this.$cookies.get('userToken')}`);
                    this.profile_done_status = (this.agency_status.to_do.filter(task => task.done).length / this.agency_status.to_do.length * 100).toFixed(0);
                    this.loading = false;
                }, 1000);
            }
        },
        async mounted() {
            // Initial check when the component is mounted
            if (this.$route.query.showDialog === 'true') {
                this.isDialogOpen = true;
                // Optionally, remove the query parameter from the URL to keep it clean
                this.$router.replace({ query: { ...this.$route.query, showDialog: undefined } });
            }
            await this.getAgencyStatus();
        },
        watch: {
            // Watch for changes to the route's query.showDialog parameter
            '$route.query.showDialog'(newValue) {
            if (newValue === 'true') {
                this.isDialogOpen = true;
                // Optionally, remove the query parameter from the URL to keep it clean
                this.$router.replace({ query: { ...this.$route.query, showDialog: undefined } });
            }
            },
        },
    }
</script>